import { parsePhoneNumber, getCountryCallingCode } from "libphonenumber-js";
import { findFlagUrlByIso2Code } from "country-flags-svg";

const parse=(msisdn,country)=>{
    if(country === "xx") return msisdn;
    try{
        const parsed=parsePhoneNumber(msisdn,country.toUpperCase());
        return parsed.number.replace("+","");
    }
    catch(e){
        return msisdn;
    }

}
const isvalidNumber=(msisdn,country)=>{
    if(country === "xx") return true;
    try{
        const parsed=parsePhoneNumber(msisdn,country.toUpperCase());
        return parsed.isPossible();
    }
    catch(e){
        return false;
    }
}

const getPlaceHolder=(country)=>{
    if(country === 'xx') return "";
    country=country.toUpperCase();
    return getCountryCallingCode(country) + "xxxxxxxx";
}

const getFlag = (country) => {
    if(country === "xx") return null;
    else return findFlagUrlByIso2Code(country.toUpperCase());
}


export{ isvalidNumber, getPlaceHolder, parse, getFlag }


// WEBPACK FOOTER //
// ./src/utils/loginUtils.js